var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1483_8661",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1483_8661)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1483_8661)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1483_8661",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -3,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 23C2.81984 23 -3 17.1802 -3 10C-3 2.81984 2.81984 -3 10 -3C17.1802 -3 23 2.81984 23 10C23 17.1802 17.1802 23 10 23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1483_8661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 9.99981L-8.38672 9.88645L-8.37008 9.21045L10.0005 9.99981Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99868 10L-8.375 9.32296L-8.34692 8.75928L9.99868 10Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 10.0001L-8.35156 8.8727L-8.30996 8.31006L10.0003 10.0001Z",
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0022 10.0001L-8.31641 8.42244L-8.26129 7.86084L10.0022 10.0001Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 10.0001L-8.27344 7.97309L-8.2048 7.41357L10.0004 10.0001Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99997 9.99992L-8.21875 7.52576L-8.13659 6.96729L9.99997 9.99992Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99982 10.0002L-8.15234 7.0788L-8.05666 6.52344L9.99982 10.0002Z",
    fill: "#F8FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 9.99977L-8.07422 6.63433L-7.96502 6.08105L10.001 9.99977Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99956 9.99975L-7.98828 6.19231L-7.86452 5.64111L9.99956 9.99975Z",
    fill: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0023 10L-7.88672 5.75163L-7.74944 5.20459L10.0023 10Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0015 10.0002L-7.77734 5.31394L-7.62758 4.77002L10.0015 10.0002Z",
    fill: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99904 10.0001L-7.66016 4.87912L-7.49584 4.33936L9.99904 10.0001Z",
    fill: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 9.99978L-7.52734 4.44722L-7.3495 3.91162L10.0008 9.99978Z",
    fill: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99978L-7.38672 4.01875L-7.1964 3.4873L10 9.99978Z",
    fill: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99946 10L-7.23438 3.59362L-7.03157 3.06738L9.99946 10Z",
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 10L-7.07031 3.17241L-6.85503 2.65137L10.0013 10Z",
    fill: "#EFF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 10.0002L-6.89844 2.75552L-6.66964 2.24072L10.0005 10.0002Z",
    fill: "#EEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0011 10.0001L-6.71484 2.34358L-6.47356 1.83398L10.0011 10.0001Z",
    fill: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 10.0002L-6.52344 1.93604L-6.26968 1.43164L10.0001 10.0002Z",
    fill: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 9.99996L-6.32031 1.53228L-6.05407 1.03516L10.0004 9.99996Z",
    fill: "#EBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0021 9.99995L-6.10547 1.13499L-5.82779 0.643066L10.0021 9.99995Z",
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0021 9.99998L-5.88281 0.741901L-5.59265 0.258301L10.0021 9.99998Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 9.99976L-5.65234 0.354801L-5.35074 -0.122559L10.0007 9.99976Z",
    fill: "#E8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0016 10.0001L-5.41016 -0.0265656L-5.09608 -0.495605L10.0016 10.0001Z",
    fill: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 10L-5.16016 -0.402073L-4.83568 -0.862793L10.001 10Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99878 10L-4.90234 -0.770193L-4.56642 -1.22363L9.99878 10Z",
    fill: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 10.0002L-4.63281 -1.133L-4.28545 -1.57812L9.99999 10.0002Z",
    fill: "#E4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99965 9.99984L-4.35547 -1.48904L-3.99771 -1.9248L9.99965 9.99984Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0017 10.0001L-4.06641 -1.83721L-3.69825 -2.26465L10.0017 10.0001Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 9.99986L-3.77344 -2.17958L-3.39488 -2.59766L10.0003 9.99986Z",
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0024 10.0001L-3.46875 -2.51316L-3.07979 -2.92188L10.0024 10.0001Z",
    fill: "#E0EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99994L-3.16016 -2.8399L-2.7608 -3.23926L10 9.99994Z",
    fill: "#DFE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L-2.83984 -3.15993L-2.43216 -3.54785L10 10.0002Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0016 10.0001L-2.51172 -3.47105L-2.09364 -3.84961L10.0016 10.0001Z",
    fill: "#DDE8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99975 9.99983L-2.17969 -3.77393L-1.75225 -4.14209L9.99975 9.99983Z",
    fill: "#DCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 10.0001L-1.83594 -4.06802L-1.40018 -4.42578L10.0013 10.0001Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 9.99978L-1.48828 -4.35534L-1.04316 -4.70166L10.0006 9.99978Z",
    fill: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 9.99997L-1.13281 -4.63283L-0.679372 -4.96875L10.0004 9.99997Z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 10L-0.769531 -4.90111L-0.308811 -5.22559L10.0007 10Z",
    fill: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99974 10L-0.402344 -5.16108L0.0666962 -5.47412L9.99974 10Z",
    fill: "#D7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9993 9.99998L-0.0273438 -5.41178L0.450016 -5.71338L9.9993 9.99998Z",
    fill: "#D6E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 9.99984L0.355469 -5.6532L0.839069 -5.94336L10.0004 9.99984Z",
    fill: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 10L0.742188 -5.88492L1.23307 -6.1626L10.0003 10Z",
    fill: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0017 10.0002L1.13672 -6.1073L1.63384 -6.37354L10.0017 10.0002Z",
    fill: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99893 10.0002L1.53125 -6.32052L2.03565 -6.57324L9.99893 10.0002Z",
    fill: "#D2E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0017 10.0001L1.9375 -6.52343L2.4471 -6.76367L10.0017 10.0001Z",
    fill: "#D1E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 9.9999L2.34375 -6.71602L2.85959 -6.94482L10.0002 9.9999Z",
    fill: "#D0DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99855 10L2.75391 -6.89891L3.27599 -7.11523L9.99855 10Z",
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99947 9.99999L3.17188 -7.07161L3.69916 -7.27441L9.99947 9.99999Z",
    fill: "#CEDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 9.99984L3.59375 -7.234L4.12519 -7.42432L10.0001 9.99984Z",
    fill: "#CDDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 9.99998L4.01953 -7.38674L4.55513 -7.5625L10.0006 9.99998Z",
    fill: "#CCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0018 10L4.44922 -7.52813L4.98898 -7.69141L10.0018 10Z",
    fill: "#CBDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99987 9.99988L4.87891 -7.65932L5.42283 -7.80908L9.99987 9.99988Z",
    fill: "#CADBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99874 10.0001L5.3125 -7.77874L5.85954 -7.91602L9.99874 10.0001Z",
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0023 10L5.75391 -7.889L6.30407 -8.01172L10.0023 10Z",
    fill: "#C8DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99885 9.99987L6.19141 -7.98797L6.74365 -8.09717L9.99885 9.99987Z",
    fill: "#C7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0022 10L6.63672 -8.07516L7.19208 -8.17188L10.0022 10Z",
    fill: "#C6D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99949 10L7.07812 -8.15215L7.63661 -8.23535L9.99949 10Z",
    fill: "#C5D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0015 9.99976L7.52734 -8.21896L8.08686 -8.2876L10.0015 9.99976Z",
    fill: "#C4D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99962 9.99986L7.97266 -8.27398L8.53426 -8.3291L9.99962 9.99986Z",
    fill: "#C3D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99955 9.99981L8.42188 -8.31875L8.98451 -8.36035L9.99955 9.99981Z",
    fill: "#C2D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0024 9.99997L8.875 -8.35187L9.43868 -8.37891L10.0024 9.99997Z",
    fill: "#C1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 9.99999L9.32422 -8.37369L9.8879 -8.38721L10.0013 9.99999Z",
    fill: "#C0D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99912 9.99987L9.77344 -8.38525H10.3371L9.99912 9.99987Z",
    fill: "#BFD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99987L10.2257 -8.38525L10.7894 -8.37069L10 9.99987Z",
    fill: "#BED3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L10.677 -8.37354L11.2397 -8.34546L10 10.0001Z",
    fill: "#BDD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99979L11.1274 -8.35205L11.69 -8.31045L10 9.99979Z",
    fill: "#BCD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L11.5777 -8.31836L12.1393 -8.26324L10 10.0002Z",
    fill: "#BBD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99991L12.0259 -8.27393L12.5865 -8.20529L10 9.99991Z",
    fill: "#BAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99997L12.4742 -8.21875L13.0326 -8.13659L10 9.99997Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99982L12.9203 -8.15234L13.4767 -8.05666L10 9.99982Z",
    fill: "#B8CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L13.3654 -8.0752L13.9187 -7.966L10 10Z",
    fill: "#B7CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L13.8074 -7.98779L14.3586 -7.86403L10 10Z",
    fill: "#B6CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99988L14.2484 -7.88916L14.7954 -7.75188L10 9.99988Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99999L14.6862 -7.77881L15.2291 -7.62905L10 9.99999Z",
    fill: "#B4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L15.121 -7.65918L15.6607 -7.49486L10 10Z",
    fill: "#B3CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99984L15.5526 -7.52832L16.0882 -7.35048L10 9.99984Z",
    fill: "#B2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L15.981 -7.38672L16.5125 -7.1964L10 10Z",
    fill: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99995L16.4064 -7.23389L16.9326 -7.03109L10 9.99995Z",
    fill: "#B0C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99982L16.8266 -7.07178L17.3486 -6.8565L10 9.99982Z",
    fill: "#AFC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L17.2436 -6.89893L17.7594 -6.67013L10 10Z",
    fill: "#AEC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L17.6565 -6.71582L18.1661 -6.47454L10 10.0001Z",
    fill: "#ADC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L18.0642 -6.52344L18.5686 -6.26968L10 10.0001Z",
    fill: "#ACC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99992L18.4677 -6.3208L18.9648 -6.05456L10 9.99992Z",
    fill: "#ABC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L18.865 -6.10742L19.3569 -5.82974L10 10.0001Z",
    fill: "#AAC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L19.2581 -5.88477L19.7417 -5.59461L10 10.0002Z",
    fill: "#A9C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L19.645 -5.65283L20.1213 -5.35123L10 10.0002Z",
    fill: "#A8C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L20.0266 -5.41162L20.4957 -5.09754L10 10.0001Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99999L20.4021 -5.16113L20.8628 -4.83665L10 9.99999Z",
    fill: "#A6C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99975L20.7702 -4.90137L21.2237 -4.56545L10 9.99975Z",
    fill: "#A5C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99999L21.1332 -4.63281L21.5773 -4.28545L10 9.99999Z",
    fill: "#A4C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L21.4889 -4.35498L21.9246 -3.99722L10 10.0001Z",
    fill: "#A3C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L21.8373 -4.06787L22.2647 -3.69971L10 10.0002Z",
    fill: "#A2C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99983L22.1794 -3.77393L22.5975 -3.39537L10 9.99983Z",
    fill: "#A1BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99993L22.5133 -3.47119L22.922 -3.08223L10 9.99993Z",
    fill: "#A0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L22.8398 -3.16016L23.2392 -2.7608L10 10Z",
    fill: "#9FBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L23.1591 -2.83984L23.5481 -2.43216L10 10Z",
    fill: "#9EBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L23.4711 -2.51318L23.8497 -2.0951L10 10.0001Z",
    fill: "#9DBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99975L23.7738 -2.17969L24.1419 -1.75225L10 9.99975Z",
    fill: "#9CBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99988L24.0681 -1.8374L24.4258 -1.40164L10 9.99988Z",
    fill: "#9BBBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L24.3551 -1.48877L24.7014 -1.04365L10 10.0001Z",
    fill: "#9ABAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.9999L24.6328 -1.1333L24.9687 -0.679861L10 9.9999Z",
    fill: "#99BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L24.9011 -0.77002L25.2256 -0.309299L10 10.0002Z",
    fill: "#98B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L25.1611 -0.401855L25.4742 0.0671844L10 10.0002Z",
    fill: "#97B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99978L25.4118 -0.0268555L25.7134 0.450504L10 9.99978Z",
    fill: "#96B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99994L25.653 0.35498L25.9432 0.83858L10 9.99994Z",
    fill: "#95B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99978L25.885 0.741699L26.1626 1.23258L10 9.99978Z",
    fill: "#94B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L26.1075 1.13525L26.3727 1.63237L10 10.0002Z",
    fill: "#93B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99991L26.3197 1.53223L26.5734 2.03663L10 9.99991Z",
    fill: "#92B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L26.5235 1.93604L26.7638 2.44563L10 10.0002Z",
    fill: "#91B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L26.7159 2.34375L26.9447 2.85959L10 10.0002Z",
    fill: "#90B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L26.899 2.75537L27.1142 3.27745L10 10Z",
    fill: "#8FB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99996L27.0716 3.17236L27.2744 3.69964L10 9.99996Z",
    fill: "#8EB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L27.2338 3.59375L27.4242 4.12519L10 10.0001Z",
    fill: "#8DB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L27.3857 4.01904L27.5625 4.55464L10 10.0001Z",
    fill: "#8CB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99983L27.5271 4.44727L27.6914 4.98703L10 9.99983Z",
    fill: "#8BB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99987L27.6582 4.87891L27.809 5.42283L10 9.99987Z",
    fill: "#8AB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L27.7788 5.31396L27.9161 5.861L10 10.0002Z",
    fill: "#89AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99986L27.889 5.75146L28.0118 6.30163L10 9.99986Z",
    fill: "#88AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99982L27.9868 6.19238L28.097 6.74462L10 9.99982Z",
    fill: "#87AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0002L28.0752 6.63477L28.1719 7.19013L10 10.0002Z",
    fill: "#86ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99997L28.1522 7.07861L28.2354 7.63709L10 9.99997Z",
    fill: "#85ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.2187 7.52588L28.2874 8.0854L10 10Z",
    fill: "#84ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L28.2738 7.97314L28.329 8.53474L10 10.0001Z",
    fill: "#83ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.3186 8.42236L28.3602 8.985L10 10Z",
    fill: "#82AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99992L28.3518 8.87256L28.3789 9.43624L10 9.99992Z",
    fill: "#81AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99979L28.3737 9.32275L28.3872 9.88643L10 9.99979Z",
    fill: "#80A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.0001L28.3841 9.77441V10.3381L10 10.0001Z",
    fill: "#7FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.3841 10.2257L28.3706 10.7894L10 10Z",
    fill: "#7EA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.3737 10.677L28.3456 11.2397L10 10Z",
    fill: "#7DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.3518 11.1274L28.3102 11.69L10 10Z",
    fill: "#7CA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.3186 11.5777L28.2634 12.1393L10 10Z",
    fill: "#7BA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.2738 12.0259L28.2052 12.5865L10 10Z",
    fill: "#7AA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.2187 12.4742L28.1355 13.0326L10 10Z",
    fill: "#79A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.1522 12.9203L28.0565 13.4767L10 10Z",
    fill: "#78A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L28.0752 13.3654L27.965 13.9187L10 10Z",
    fill: "#77A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.9868 13.8074L27.8641 14.3586L10 10Z",
    fill: "#76A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.889 14.2484L27.7518 14.7954L10 10Z",
    fill: "#75A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.7788 14.6862L27.629 15.2291L10 10Z",
    fill: "#74A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.6582 15.121L27.4949 15.6607L10 10Z",
    fill: "#73A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.5271 15.5526L27.3503 16.0882L10 10Z",
    fill: "#729FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.3857 15.981L27.1964 16.5125L10 10Z",
    fill: "#719FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.2338 16.4064L27.031 16.9326L10 10Z",
    fill: "#709EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L27.0716 16.8266L26.8553 17.3486L10 10Z",
    fill: "#6F9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L26.899 17.2436L26.6702 17.7594L10 10Z",
    fill: "#6E9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L26.7159 17.6565L26.4746 18.1661L10 10Z",
    fill: "#6D9CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L26.5235 18.0642L26.2698 18.5686L10 10Z",
    fill: "#6C9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L26.3197 18.4677L26.0545 18.9648L10 10Z",
    fill: "#6B9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L26.1075 18.865L25.8298 19.3569L10 10Z",
    fill: "#6A9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L25.885 19.2581L25.5948 19.7417L10 10Z",
    fill: "#6999FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L25.653 19.645L25.3514 20.1213L10 10Z",
    fill: "#6899FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L25.4118 20.0266L25.0977 20.4957L10 10Z",
    fill: "#6798FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L25.1611 20.4021L24.8366 20.8628L10 10Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L24.9011 20.7702L24.5652 21.2237L10 10Z",
    fill: "#6597FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L24.6328 21.1332L24.2854 21.5773L10 10Z",
    fill: "#6496FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L24.3551 21.4889L23.9974 21.9246L10 10Z",
    fill: "#6395FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L24.0681 21.8373L23.6999 22.2647L10 10Z",
    fill: "#6294FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L23.7738 22.1794L23.3952 22.5975L10 10Z",
    fill: "#6194FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L23.4711 22.5133L23.0822 22.922L10 10Z",
    fill: "#6093FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L23.1591 22.8398L22.7608 23.2392L10 10Z",
    fill: "#5F92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L22.8398 23.1591L22.4322 23.5481L10 10Z",
    fill: "#5E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L22.5133 23.4711L22.0952 23.8497L10 10Z",
    fill: "#5D91FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L22.1794 23.7738L21.752 24.1419L10 10Z",
    fill: "#5C90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L21.8373 24.0681L21.4015 24.4258L10 10Z",
    fill: "#5B90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L21.4889 24.3551L21.0438 24.7014L10 10Z",
    fill: "#5A8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L21.1332 24.6328L20.6798 24.9687L10 10Z",
    fill: "#598EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L20.7702 24.9011L20.3095 25.2256L10 10Z",
    fill: "#588EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L20.4021 25.1611L19.932 25.4742L10 10Z",
    fill: "#578DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L20.0266 25.4118L19.5493 25.7134L10 10Z",
    fill: "#568CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L19.645 25.653L19.1614 25.9432L10 10Z",
    fill: "#558CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L19.2581 25.885L18.7672 26.1626L10 10Z",
    fill: "#548BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L18.865 26.1075L18.3678 26.3727L10 10Z",
    fill: "#538AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L18.4677 26.3197L17.9633 26.5734L10 10Z",
    fill: "#528AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L18.0642 26.5235L17.5546 26.7638L10 10Z",
    fill: "#5189FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L17.6565 26.7159L17.1406 26.9447L10 10Z",
    fill: "#5088FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L17.2436 26.899L16.7226 27.1142L10 10Z",
    fill: "#4F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L16.8266 27.0716L16.3003 27.2744L10 10Z",
    fill: "#4E87FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L16.4064 27.2338L15.875 27.4242L10 10Z",
    fill: "#4D86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L15.981 27.3857L15.4454 27.5625L10 10Z",
    fill: "#4C86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L15.5526 27.5271L15.0128 27.6914L10 10Z",
    fill: "#4B85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L15.121 27.6582L14.577 27.809L10 10Z",
    fill: "#4A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L14.6862 27.7788L14.1382 27.9161L10 10Z",
    fill: "#4984FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L14.2484 27.889L13.6982 28.0118L10 10Z",
    fill: "#4883FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L13.8074 27.9868L13.2542 28.097L10 10Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L13.3654 28.0752L12.8101 28.1719L10 10Z",
    fill: "#4681FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L12.9203 28.1522L12.3629 28.2354L10 10Z",
    fill: "#4581FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L12.4742 28.2187L11.9146 28.2874L10 10Z",
    fill: "#4480FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L12.0259 28.2738L11.4654 28.329L10 10Z",
    fill: "#437FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L11.5777 28.3186L11.015 28.3602L10 10Z",
    fill: "#427FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L11.1274 28.3518L10.5637 28.3789L10 10Z",
    fill: "#417EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L10.677 28.3737L10.1123 28.3872L10 10Z",
    fill: "#407DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9992 10L10.2249 28.3841H9.66016L9.9992 10Z",
    fill: "#3F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 10L9.77462 28.3841L9.21094 28.3706L10.0003 10Z",
    fill: "#3E7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99853 10L9.32149 28.3737L8.75781 28.3456L9.99853 10Z",
    fill: "#3D7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99859 10L8.87123 28.3518L8.30859 28.3102L9.99859 10Z",
    fill: "#3C7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99865 10L8.42098 28.3186L7.85938 28.2634L9.99865 10Z",
    fill: "#3B7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 10L7.97358 28.2738L7.41406 28.2052L10.0005 10Z",
    fill: "#3A79FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0014 10L7.52723 28.2187L6.96875 28.1355L10.0014 10Z",
    fill: "#3979FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 10L7.0788 28.1522L6.52344 28.0565L10.0002 10Z",
    fill: "#3878FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 10L6.63531 28.0752L6.08203 27.965L10.0008 10Z",
    fill: "#3777FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99926 10L6.19182 27.9868L5.64062 27.8641L9.99926 10Z",
    fill: "#3677FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99856 10L5.75016 27.889L5.20312 27.7518L9.99856 10Z",
    fill: "#3576FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99969 10L5.31345 27.7788L4.76953 27.629L9.99969 10Z",
    fill: "#3475FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 10L4.8796 27.6582L4.33984 27.4949L10.0006 10Z",
    fill: "#3375FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0022 10L4.44966 27.5271L3.91406 27.3503L10.0022 10Z",
    fill: "#3274FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 10L4.01972 27.3857L3.48828 27.1964L10.0008 10Z",
    fill: "#3173FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99905 10L3.59265 27.2338L3.06641 27.031L9.99905 10Z",
    fill: "#3073FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 10L3.17338 27.0716L2.65234 26.8553L10.001 10Z",
    fill: "#2F72FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0016 10L2.75699 26.899L2.24219 26.6702L10.0016 10Z",
    fill: "#2E71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 10L2.34554 26.7159L1.83594 26.4746L10.002 10Z",
    fill: "#2D71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0022 10L1.93799 26.5235L1.43359 26.2698L10.0022 10Z",
    fill: "#2C70FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 10L1.53228 26.3197L1.03516 26.0545L9.99996 10Z",
    fill: "#2B6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0014 10L1.13645 26.1075L0.644531 25.8298L10.0014 10Z",
    fill: "#2A6EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99949 10L0.741412 25.885L0.257812 25.5948L9.99949 10Z",
    fill: "#296EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0012 10L0.356266 25.653L-0.121094 25.3514L10.0012 10Z",
    fill: "#286DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99959 10L-0.0270538 25.4118L-0.496094 25.0977L9.99959 10Z",
    fill: "#276CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99952 10L-0.402561 25.1611L-0.863281 24.8366L9.99952 10Z",
    fill: "#266CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 10L-0.769216 24.9011L-1.22266 24.5652L10.001 10Z",
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 10L-1.133 24.6328L-1.57812 24.2854L10.0002 10Z",
    fill: "#246AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99886 10L-1.49002 24.3551L-1.92578 23.9974L9.99886 10Z",
    fill: "#236AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99909 10L-1.83818 24.0681L-2.26562 23.6999L9.99909 10Z",
    fill: "#2269FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99986 10L-2.17958 23.7738L-2.59766 23.3952L9.99986 10Z",
    fill: "#2168FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 10L-2.51316 23.4711L-2.92188 23.0822L10.0001 10Z",
    fill: "#2068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0009 10L-2.83892 23.1591L-3.23828 22.7608L10.0009 10Z",
    fill: "#1F67FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0012 10L-3.15895 22.8398L-3.54688 22.4322L10.0012 10Z",
    fill: "#1E66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 10L-3.4691 22.5133L-3.84766 22.0952L10.002 10Z",
    fill: "#1D66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 10L-3.77246 22.1794L-4.14062 21.752L10.0013 10Z",
    fill: "#1C65FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 10L-4.06802 21.8373L-4.42578 21.4015L10.0001 10Z",
    fill: "#1B64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0022 10L-4.3529 21.4889L-4.69922 21.0438L10.0022 10Z",
    fill: "#1A64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99997 10L-4.63283 21.1332L-4.96875 20.6798L9.99997 10Z",
    fill: "#1963FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99904 10L-4.90208 20.7702L-5.22656 20.3095L9.99904 10Z",
    fill: "#1862FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0015 10L-5.15962 20.4021L-5.47266 19.932L10.0015 10Z",
    fill: "#1762FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0024 10L-5.40934 20.0266L-5.71094 19.5493L10.0024 10Z",
    fill: "#1661FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0018 10L-5.65125 19.645L-5.94141 19.1614L10.0018 10Z",
    fill: "#1560FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99858 10L-5.88638 19.2581L-6.16406 18.7672L9.99858 10Z",
    fill: "#1460FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99876 10L-6.10876 18.865L-6.375 18.3678L9.99876 10Z",
    fill: "#135FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99922 10L-6.3215 18.4677L-6.57422 17.9633L9.99922 10Z",
    fill: "#125EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 10L-6.52148 18.0642L-6.76172 17.5546L10.002 10Z",
    fill: "#115EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99941 10L-6.71651 17.6565L-6.94531 17.1406L9.99941 10Z",
    fill: "#105DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 10L-6.89696 17.2436L-7.11328 16.7226L10.002 10Z",
    fill: "#0F5CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 10L-7.07064 16.8266L-7.27344 16.3003L10.001 10Z",
    fill: "#0E5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0023 10L-7.23156 16.4064L-7.42188 15.875L10.0023 10Z",
    fill: "#0D5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 10L-7.38674 15.981L-7.5625 15.4454L9.99998 10Z",
    fill: "#0C5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L-7.52813 15.5526L-7.69141 15.0128L10 10Z",
    fill: "#0B59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 10L-7.65883 15.121L-7.80859 14.577L10.0004 10Z",
    fill: "#0A59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 10L-7.77678 14.6862L-7.91406 14.1382L10.002 10Z",
    fill: "#0958FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L-7.889 14.2484L-8.01172 13.6982L10 10Z",
    fill: "#0857FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99938 10L-7.98846 13.8074L-8.09766 13.2542L9.99938 10Z",
    fill: "#0757FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10L-8.07516 13.3654L-8.17188 12.8101L10 10Z",
    fill: "#0656FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 10L-8.15118 12.9203L-8.23438 12.3629L10.001 10Z",
    fill: "#0555FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0022 10L-8.21652 12.4742L-8.28516 11.9146L10.0022 10Z",
    fill: "#0455FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 10L-8.273 12.0259L-8.32812 11.4654L10.0008 10Z",
    fill: "#0354FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 10L-8.31777 11.5777L-8.35938 11.015L10.0008 10Z",
    fill: "#0253FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99997 10L-8.35187 11.1274L-8.37891 10.5637L9.99997 10Z",
    fill: "#0153FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 10L-8.3732 10.677L-8.38672 10.1123L10.0005 10Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0023 10.0001L-8.38281 10.2258V9.77441L10.0023 10.0001Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1483_8661"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -3,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.31e55d62ed753b3be0bcac2c55944e47.svg";
export { ForwardRef as ReactComponent };